<template>
  <div>
    <Manage_website/>
  </div>
</template>

<script>
import Manage_website from "@/components/adminArin/setting_website/Manage_website";
export default {
  name: "ManageWebsite",
  components: {
    Manage_website
  }
}
</script>

<style scoped>

</style>
